import {getErrorMessageFromResponse, hasAccess} from "../common/helper";
import {enqueueSnackbar} from "notistack";

export function checkHasMultiSelectActions(actionsConfig, userRoles){
    // console.log (actionsConfig, userRoles)
    let hasMultiSelectActions = false;

    //add checks here for all multi select actions, currently only one is downloadFileMulti
    if (actionsConfig.downloadFileMulti.enabled) {
        if (hasAccess(actionsConfig.downloadFileMulti, userRoles)) {
            hasMultiSelectActions = true
        }
    }

    //add checks here for all multi select actions, currently only one is downloadFileMulti
    if (actionsConfig.deleteFileMulti && actionsConfig.deleteFileMulti.enabled) {
        if (hasAccess(actionsConfig.deleteFileMulti, userRoles)) {
            hasMultiSelectActions = true
        }
    }
    return hasMultiSelectActions
}
//downloadFileMultiFolderDocs

export function checkHasMultiSelectActionsFolderDocs(actionsConfig, userRoles){
    // console.log (actionsConfig, userRoles)
    let hasMultiSelectActions = false;

    //add checks here for all multi select actions, currently only one is downloadFileMulti
    if (actionsConfig.downloadFileMultiFolderDocs && actionsConfig.downloadFileMultiFolderDocs.enabled) {
        if (hasAccess(actionsConfig.downloadFileMultiFolderDocs, userRoles)) {
            hasMultiSelectActions = true
        }
    }

    return hasMultiSelectActions
}

export async function downloadFileMulti(data,  accessToken, triggerRefreshAuthToken, updateIsProcessing, filename){

    //console.log('** evt=', evt);
    console.log ('downloadFileMulti, data=', data)

    const pathVar = "/download";
    const params =  ""; // "?userId=" + props.userDetails.boxId;
    const url = process.env.REACT_APP_CONTENT_API_BASE_URL + process.env.REACT_APP_CONTENT_API_DOCUMENT + pathVar + params ;

    //Build array of ids from the selected files
    let files = [];
    data.map((file) => {
        files.push(file.id);
        return null;
    });

    const request = {
        method: 'POST',
        headers: {"Authorization": "Bearer " + accessToken},
        body: files
    };

    window.location.pathname.toLowerCase().includes("debug") && console.log ('url = ', url, 'request = ', request);

    await triggerRefreshAuthToken();
    updateIsProcessing(true, false);
    fetch(url , request )
        .then(response => {
            if (response.ok) {
                window.location.pathname.toLowerCase().includes("debug") && console.log('response.ok - download RESPONSE = ', response);
                return (response.blob())
            } else {
                return null
            }
        })
        .then(result => {

            const url = URL.createObjectURL(result);
            const fileName =  files.length === 1 ? data[0].name : filename ? filename + '.zip' :"download.zip" ;

            // Create a new anchor element
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            updateIsProcessing(false, true);
            enqueueSnackbar("Download of " + data.length + " files complete", {variant: 'success'});

        })
        .catch(e => {
            window.location.pathname.toLowerCase().includes("debug") && console.log("download Exception:", e, " url:", url, "request: ", request);
            updateIsProcessing(false, false)
            enqueueSnackbar("Error downloading file: " + e, {variant: 'error'});
        })

}

export async function deleteFileMulti(data,  accessToken, triggerRefreshAuthToken, updateIsProcessing){

    //console.log('** evt=', evt);
    console.log ('deleteFileMulti, data=', data)


    updateIsProcessing(true, false);

    let successFiles =[];
    let errorFiles = [];

    const params =  "?audit=true";
    const request = {
        method: 'DELETE',
        headers: {"Authorization": "Bearer " + accessToken},
    };

    await triggerRefreshAuthToken();

    //Loop through selected files to delete

    // data.forEach(file => {
    for (const file of data) {
        console.log ('DELETE' , file.name, file.id )

        const url = process.env.REACT_APP_CONTENT_API_BASE_URL + process.env.REACT_APP_CONTENT_API_DOCUMENT + "/" + file.id + params ;

        window.location.pathname.toLowerCase().includes("debug") && console.log ('url = ', url, 'request = ', request);

        await fetch(url , request )
            .then(response => {
                window.location.pathname.toLowerCase().includes("debug") && console.log('response.ok - download RESPONSE = ', response);
                if (response.ok) {
                    successFiles.push(file)
                    enqueueSnackbar("Delete complete " + file.name, {variant: 'success'});
                } else {
                    Promise.resolve(getErrorMessageFromResponse(response, 'deleting file'))
                        .then(message => {
                            file.error = message
                            errorFiles.push(file)
                            enqueueSnackbar(message ,  {variant: 'error'})
                        })
                }

            })
            .catch(e => {
                window.location.pathname.toLowerCase().includes("debug") && console.log("delete Exception:", e, " url:", url, "request: ", request);
                file.error =  e
                errorFiles.push(file)
                enqueueSnackbar("Error, exception on delete", {variant: 'error'});

            })
    }

    updateIsProcessing(false, true);
    exportToCSV(errorFiles,"deleteErrors.csv")
    exportToCSV(successFiles,"deleteSuccess.csv")

}

export const exportToCSV = (data, filename = "data.csv") => {

    console.log ('exportToCSV', filename, data)

    if (!data || data.length === 0) {
        console.log(`exportToCSV skipped — no data for ${filename}`);
        return;
    }

    const headers = Object.keys(data[0]).join(",");
    const rows = data.map(obj =>
        Object.values(obj)
            .map(value => `"${String(value).replace(/"/g, '""')}"`)
            .join(",")
    );

    const csv = [headers, ...rows].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
};


